import { request } from "../http/http"
import EntityService from "./entity";

class AuthenticationService extends EntityService {

	constructor(name) {
		super(name)
	}

	async addAuthenticationPhoneVerificationCode(entity) {
		const result = await request({
			url: `/web/login/phone-verification-code`,
			method: "post",
			data: entity,
		});

		return result;
	}
  async testEmailExist(email) {
    const result = await request({
      url: "/web/login/emailIsExist",
      method: "post",
      params: { email }
    })
    return result;
  }
}

export default new AuthenticationService("authentication");



// WEBPACK FOOTER //
// ./src/services/authentication.js